export enum Environment {
  Development,
  Test,
  Production
}
